import React, { useContext } from "react";
import { EditorContext } from "../EditorCommon/EditorContext";
import { ProductGroup } from "./ProductGroup";


export function ProductList() {

    const ec = useContext(EditorContext);

    const groupCards = ec.cabinetService.getProductLine()?.interiorProducts
        .map(ipGroup => (<ProductGroup group={ipGroup} key={ipGroup.id} />) );

    return (
        <div
            className="product-list"
            style={{
            display: "flex",
            flexDirection: "column",
        }}>
            {groupCards}
        </div>
    );
}
